import { apiConfig } from 'config';
import { handle420 } from 'apis/HandleError';
import { fetchdata } from '../FetchData';

export function deleteProvisionSu(deviceId, suId) {
  const url = apiConfig.cmServiceDeleteProvisionSu(deviceId, suId);

  return fetchdata(url, { method: 'DELETE' })
    .then((result) => {
      return result;
    })
    .catch((e) => {
      switch (e.message) {
        case '420':
          handle420();
          break;
        default:
          throw e;
      }
    });
}
